var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-selection",class:{
    'card-selection--active': _vm.activeValue
  },on:{"click":function($event){_vm.$emit('selectedOption') ? _vm.$emit('selectedOption') : ''}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }